import { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Rate } from '../../../../lib/ui/Rate';
import type { AnswersViewProps } from '../AnswersView';
import type { GraphicSelectModel } from './GraphicSelectModel';
import { GraphicSelectNumModel } from './GraphicSelectNumModel';
import { appFactory } from '@/app';

export const GraphicSelect: FC<AnswersViewProps<GraphicSelectModel>> = observer(({ questionModel }) => {
  const { selectedAnswers, handleSelectStar, disabled } = questionModel;

  const selectedStarNumber = selectedAnswers.at(0)?.answer_number;

  return (
    <Rate
      value={selectedStarNumber}
      disabled={disabled}
      onChange={handleSelectStar}
      numbered={questionModel instanceof GraphicSelectNumModel}
      themeId={appFactory.app?.currentTheme?.id}
      isDarkMode={appFactory.app?.isDarkMode}
    />
  );
});
